<nav class="navbar navbar-dark bg-dark fixed-bottom" style="padding: 0; height: 45px;">
    <div class="col-12 p-2" style="padding: 0;">
        <div class="row text-center text-white">
            <div class="col-6 p-1 border-end" style="padding: 5px 0;">
                <div routerLink="/alert-truckers-filter/0">Alert Truckers</div>
            </div>
            <div class="col-6 p-1" style="padding: 5px 0;">
                <div routerLink="/alert-truckers-filter/0">Send Dispatch</div>
            </div>
        </div>
    </div>
    
  </nav>